"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  en: {
    month: 'Month',
    year: 'Year',
    choosePlan: 'Choose plan',
    currentPlan: 'Currrent plan'
  },
  es: {
    month: 'Mes',
    year: 'Año',
    choosePlan: 'Elegir plan',
    currentPlan: 'Plan actual'
  },
  fr: {
    month: 'Mois',
    year: 'Annuelle',
    choosePlan: 'Choisir un forfait',
    currentPlan: 'Plan actuel'
  },
  de: {
    month: 'Monat',
    year: 'Jährlich',
    choosePlan: 'Wählen Sie einen Plan',
    currentPlan: 'Derzeitiger Plan'
  }
};
exports["default"] = _default;